import React from 'react'
import PropTypes from 'prop-types'
import Icon from '.././icons/icon'
import { COLOR_STATE_TAG } from './constants'
import values from 'lodash/values'

const StateTag = ({ colorState, className, iconName, text }) => (
  <div className={'status-tag ' + colorState + (className || '')}>
    <Icon name={iconName} />
    <span>{text}</span>
  </div>
)

StateTag.propTypes = {
  text: PropTypes.string,
  iconName: PropTypes.string,
  colorState: PropTypes.oneOf(values(COLOR_STATE_TAG)),
  className: PropTypes.string
}

export default StateTag



// WEBPACK FOOTER //
// ./src/ui/tags/state-tag.js